import qs from 'qs';
import { AxiosResponse } from 'axios';

import api, { PaginatedResponse } from '@global-apis/config';
import User, { Profile, ProjectUser } from '@global-interfaces/User';

interface SwitchCompanyProps extends User {
  access: string;
  refresh: string;
}

const userAPI = {
  list: (page?: number, params = {}) =>
    api.get<PaginatedResponse<User>>('users/', {
      params: { ...params, page: page ? page : 1 },
      paramsSerializer: { serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' }) }
    }),
  me: async () => api.get<User>(`users/me/`),
  fetch: async (id: number) => api.get<User>(`users/${id}/`),
  update: async (id: number, data: Partial<User>) => api.patch<User>(`users/${id}/`, data),
  createUser: async (data: Partial<User>): Promise<AxiosResponse<User, Error>> => api.post<User>('/users/', data),
  createProfile: async (data: { user: number; company_id: number }) => api.post<Profile>('/profiles/', data),
  setPassword: async (id: number, data: { password: string; password_confirm: string }) =>
    api.post<{ status: 'password set' }>(`users/${id}/set_password/`, data),
  updateProfile: async (id: number, data: Partial<Profile>) => api.patch<Profile>(`profiles/${id}/`, data),
  switchCompany: async (company_id: number) => api.post<SwitchCompanyProps>('profiles/switch-company/', { company_id }),

  projectUser: {
    list: async () => api.get<PaginatedResponse<ProjectUser>>('project-user/'),
    fetchByProject: async (projectId: number) =>
      api.get<PaginatedResponse<ProjectUser>>('project-user/', {
        params: { project: projectId },
        paramsSerializer: { serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' }) }
      }),
    update: async (data: {
      user: number;
      user_email?: string;
      user_password?: string;
      first_name?: string;
      last_name?: string;
      project: number;
      project_name: string;
      billable_rate: number;
    }) => api.patch<{ success: boolean; message: string }>('project-user/update/', data)
  },

  userProjectCostCodeRates: {
    create: async (data: { user_id: number; project_id: number; cost_code_id: number; billable_rate: string }) =>
      api.post('/user-project-cost-code-rates/', data),
    update: async (id: number, data: { billable_rate: string }) =>
      api.patch(`/user-project-cost-code-rates/${id}/`, data)
  }
};

export default userAPI;
